// Autogenerated file
export const bidStatusesEnum = {
    New: "New",
    Planned: "Planned",
    Started: "Started",
    Canceled: "Canceled",
    Done: "Done",
};
export const bidStatuses = [
    { label: "Черновик", value: "New" },
    { label: "Запланирована", value: "Planned" },
    { label: "Начата", value: "Started" },
    { label: "Отменена", value: "Canceled" },
    { label: "Выполнена", value: "Done" },
];
